<template>

    <m-edit1/>

    <m-h1 v-bind='{...{},...{}}' :style='""' class="text-center my-5" >
                <template #default>شما دسترسی به این بخش را ندارید.   </template>
                </m-h1><m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-logout-1 v-bind='{...{"iconName":"arrow-right-square","redirectRoute":"{\"name\": \"Home\"}"},...{}}' :style='""' class="logout-button" >
                <template #default>خروج   </template>
                </m-logout-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mLogout1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Logout/Logout1';

export default {
    name: 'HomeView',
    components: {mEdit1, mH1,mDiv,mLogout1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
